import extractApiErrorMessage from '../../../../../utils/helpers/extractApiErrorMessage.jsx';

const responseData = (error) => error?.data || error?.response?.data;

const nonEmptyMessages = (messages) =>
  (Array.isArray(messages) ? messages : [messages]).filter(
    (message) => typeof message === 'string' && message.trim() !== '',
  );

export const getPhdApiErrorMessage = (error, fallback) => {
  const data = responseData(error);

  if (!data && typeof error !== 'string' && error?.success !== false) {
    return fallback;
  }

  const message = extractApiErrorMessage(error);

  if (typeof message !== 'string' || message.trim() === '') {
    return fallback;
  }

  const normalized = message.trim();
  const isMachineMessage =
    /^(TypeError|Error|Exception|Rejected|SQLSTATE)(:|\[|$)/u.test(
      normalized,
    ) ||
    /^phd(?:\.|_)/u.test(normalized) ||
    normalized.includes(' at http') ||
    normalized.includes('\\Exception');

  return isMachineMessage ? fallback : normalized;
};

export const applyPhdValidationErrors = (form, error) => {
  const data = responseData(error);
  const validation = data?.validation || data?.errors;

  if (!form || !validation || typeof validation !== 'object') {
    return false;
  }

  const fields = Object.entries(validation)
    .map(([field, messages]) => ({
      name: field.split('.'),
      errors: nonEmptyMessages(messages),
    }))
    .filter(({ errors }) => errors.length > 0);

  if (fields.length === 0) {
    return false;
  }

  form.setFields(fields);
  form.scrollToField(fields[0].name, { block: 'center' });

  return true;
};
